var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "637px",
    height: "573px",
    viewBox: "0 0 637 573",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-2.6%",
    y: "-2.6%",
    width: "105.2%",
    height: "105.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.522,0 L43.630258,0 C45.2533298,-7.42242666e-16 46.5820692,1.29085613 46.6290034,2.91324921 L46.7033533,5.48332581 C46.791693,8.5369986 49.29265,10.9666516 52.3476003,10.9666516 L133.831304,10.9666516 C136.886254,10.9666516 139.387211,8.5369986 139.475551,5.48332581 L139.5499,2.91324921 C139.596835,1.29085613 140.925574,7.42242666e-16 142.548646,0 L167.656904,0 C177.886322,-1.64974968e-14 186.178904,8.29258186 186.178904,18.522 L186.178904,379.620791 C186.178904,389.85021 177.886322,398.142791 167.656904,398.142791 L18.522,398.142791 C8.29258186,398.142791 4.01575893e-14,389.85021 0,379.620791 L0,18.522 C-1.25274242e-15,8.29258186 8.29258186,-1.67360005e-15 18.522,0 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.756748,0 L199.945077,0 C204.781295,-8.88398904e-16 208.701825,3.92052962 208.701825,8.756748 L208.701825,128.010944 C208.701825,132.847162 204.781295,136.767692 199.945077,136.767692 L8.756748,136.767692 C3.92052962,136.767692 4.14497961e-15,132.847162 0,128.010944 L0,8.756748 C-5.92265936e-16,3.92052962 3.92052962,-2.66431478e-15 8.756748,0 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.2%",
    y: "-20.1%",
    width: "131.1%",
    height: "147.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0755212756   0 0 0 0 0.582569014   0 0 0 0 0.878793025  0 0 0 0.229458042 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.50398247   0 0 0 0 0.700178215   0 0 0 0 1  0 0 0 0.233828671 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4.4767697,0 L211.527368,0 C213.99982,0 216.004138,2.00990288 216.004138,4.48924372 L216.004138,122.331891 C216.004138,124.811232 213.99982,126.821135 211.527368,126.821135 L4.4767697,126.821135 C2.00431807,126.821135 0,124.811232 0,122.331891 L0,4.48924372 C0,2.00990288 2.00431807,0 4.4767697,0 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.3%",
    y: "-15.8%",
    width: "122.2%",
    height: "137.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.018993433   0 0 0 0 0.018993433   0 0 0 0 0.018993433  0 0 0 0.11 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "12.6339561%",
    x2: "50%",
    y2: "69.6185448%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "46.203666%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.8135704%",
    y1: "-28.1859254%",
    x2: "62.8140501%",
    y2: "121.546626%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07777",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.7132608%",
    y1: "-6.91691667%",
    x2: "55.1442779%",
    y2: "91.2352912%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.0127719%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "21.1626173%",
    x2: "50%",
    y2: "65.1406846%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.1359293%",
    y1: "-28.1859254%",
    x2: "62.0176018%",
    y2: "121.546626%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F07777",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.7132608%",
    y1: "-6.20629719%",
    x2: "55.1442779%",
    y2: "90.7204601%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "-3.85998276%",
    x2: "50%",
    y2: "78.2784683%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.5029159%",
    y1: "98.6431024%",
    x2: "77.0614974%",
    y2: "9.20431052%",
    id: "linearGradient-18"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28324F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222735",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.359463%",
    y1: "-28.1859254%",
    x2: "50%",
    y2: "91.0504812%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "28.0624985%",
    x2: "50%",
    y2: "61.5179936%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.3142644%",
    y1: "8.53622156%",
    x2: "50%",
    y2: "71.7700059%",
    id: "linearGradient-21"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB2B2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.05946623,0 L31.0050752,0 C32.1703772,0 33.1150411,0.925207068 33.1150411,2.06650782 L33.1150411,2.12553752 C33.1150411,3.38766735 33.7282053,4.5744924 34.7665021,5.32206367 L35.4130805,5.78759858 C36.4513773,6.53516984 37.0645414,7.72199489 37.0645414,8.98412472 L37.0645414,39.8717424 C37.0645414,42.0628424 35.2509501,43.8390799 33.0137719,43.8390799 L4.05076956,43.8390799 C1.8135913,43.8390799 1.86636192e-13,42.0628424 1.86636192e-13,39.8717424 L1.86636192e-13,8.98412472 C1.86636192e-13,7.72199489 0.613164153,6.53516984 1.65146097,5.78759858 L2.29803935,5.32206367 C3.26711638,4.62433048 3.86585562,3.54395845 3.94138051,2.37685159 L3.94950032,2.06650782 C3.94950032,0.925207068 4.89416423,0 6.05946623,0 Z",
    id: "path-22"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCDD-Pages-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reset-Password",
    transform: "translate(-139.000000, -246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(145.000000, 261.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#7367F0",
    opacity: 0.099999994,
    filter: "url(#filter-1)",
    cx: 115.530612,
    cy: 260.606928,
    rx: 115.530612,
    ry: 116.393072
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.75,52.185241 C423.998678,52.185241 374.75,101.433918 374.75,162.185241 C374.75,222.936563 423.998678,272.185241 484.75,272.185241 C545.501322,272.185241 594.75,222.936563 594.75,162.185241 C594.75,101.433918 545.501322,52.185241 484.75,52.185241 Z M485.25,99.185241 C519.767797,99.185241 547.75,127.167444 547.75,161.685241 C547.75,196.203038 519.767797,224.185241 485.25,224.185241 C450.732203,224.185241 422.75,196.203038 422.75,161.685241 C422.75,127.167444 450.732203,99.185241 485.25,99.185241 Z",
    id: "Oval",
    fill: "#00CFE8",
    fillRule: "nonzero",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#7367F0",
    strokeWidth: 30,
    opacity: 0.099999994,
    cx: 306.382653,
    cy: 38.0406627,
    rx: 37.9438776,
    ry: 38.0406627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.165026,52.185241 C545.687136,52.185241 594.75,101.433918 594.75,162.185241 C594.75,222.936563 545.687136,272.185241 485.165026,272.185241 C448.704366,272.185241 415.236646,254.152587 394.922581,224.605176 C387.529938,213.852358 390.221011,199.119858 400.933259,191.699218 C411.538385,184.352784 426.02928,186.926828 433.491111,197.412493 L433.715065,197.73266 C445.321277,214.61424 464.361798,224.873413 485.165026,224.873413 C519.656121,224.873413 547.616678,196.806962 547.616678,162.185241 C547.616678,127.909737 520.212536,100.059053 486.197778,99.5054673 L485.165026,99.4970689 C472.149519,99.4970689 461.598365,88.9059555 461.598365,75.8411549 C461.598365,62.7763544 472.149519,52.185241 485.165026,52.185241 Z",
    id: "Path",
    fill: "#00CFE8",
    fillRule: "nonzero",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Banking-App",
    transform: "translate(18.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone3",
    transform: "translate(144.974910, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.137,0 L176.226708,0 C190.10949,-1.13278991e-14 201.363708,11.2542182 201.363708,25.137 L201.363708,392.32305 C201.363708,406.205832 190.10949,417.46005 176.226708,417.46005 L25.137,417.46005 C11.2542182,417.46005 -2.31133716e-14,406.205832 -2.83662357e-14,392.32305 L-2.83662357e-14,25.137 C-2.65136725e-14,11.2542182 11.2542182,6.10293932e-15 25.137,0 Z",
    id: "Rectangle",
    fill: "#8EE9F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(7.262298, 8.412419)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#FFFFFF",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.548951049,
    fill: "#E97EFF",
    mask: "url(#mask-3)",
    cx: 70.5854613,
    cy: 242.325116,
    rx: 15.9687711,
    ry: 15.9514933
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9132318,68.3541426 L159.666932,68.3541426 C162.557636,68.3541426 164.901015,70.6975217 164.901015,73.5882263 C164.901015,76.4789309 162.557636,78.82231 159.666932,78.82231 L27.9132318,78.82231 C25.0225272,78.82231 22.6791481,76.4789309 22.6791481,73.5882263 C22.6791481,70.6975217 25.0225272,68.3541426 27.9132318,68.3541426 Z",
    id: "Rectangle",
    fillOpacity: 0.548951049,
    fill: "#E97EFF",
    mask: "url(#mask-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.596533,7.30840637 C113.319054,7.30840637 114.715433,8.64748014 114.715433,10.2993114 C114.715433,11.9144352 113.380426,13.2305475 111.710873,13.2882438 L111.596533,13.2902163 L76.3294091,13.2902163 C74.6068878,13.2902163 73.2105085,11.9511426 73.2105085,10.2993114 C73.2105085,8.6841875 74.5455161,7.36807521 76.2150692,7.31037892 L76.3294091,7.30840637 L111.596533,7.30840637 Z",
    id: "Path",
    fill: "#00CFE8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.235722,6.8099222 C125.958244,6.8099222 127.354623,8.20479072 127.354623,9.92544823 C127.354623,11.6078689 126.019615,12.9788192 124.350062,13.0389195 L124.235722,13.0409743 L124.072135,13.0409743 C122.349614,13.0409743 120.953235,11.6461057 120.953235,9.92544823 C120.953235,8.24302755 122.288242,6.87207724 123.957795,6.81197694 L124.072135,6.8099222 L124.235722,6.8099222 Z",
    id: "Path",
    fill: "#00CFE8",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BoardPieChart",
    transform: "translate(164.229391, 197.513514)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#A8EDF6",
    mask: "url(#mask-5)",
    points: "-4.68241273 -5.36343889 214.053153 -5.36343889 214.053153 34.8623528 -4.68241273 34.8623528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4031083,22.1241854 L86.2856362,22.1241854 C87.3964408,22.1241854 88.2969258,23.0246704 88.2969258,24.135475 C88.2969258,25.2462796 87.3964408,26.1467646 86.2856362,26.1467646 L19.4031083,26.1467646 C18.2923037,26.1467646 17.3918187,25.2462796 17.3918187,24.135475 C17.3918187,23.0246704 18.2923037,22.1241854 19.4031083,22.1241854 Z",
    id: "Rectangle",
    fill: "#6FA3FF",
    opacity: 0.365606399,
    mask: "url(#mask-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    mask: "url(#mask-5)",
    x: 17.3918187,
    y: 10.7268778,
    width: 37.4593019,
    height: 4.02257917
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EA5455",
    mask: "url(#mask-5)",
    x: 24.0809798,
    y: 101.905339,
    width: 37.4593019,
    height: 4.69300903
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4274843,115.313936 L45.815455,115.313936 C47.1113937,115.313936 48.1619595,116.364502 48.1619595,117.660441 C48.1619595,118.956379 47.1113937,120.006945 45.815455,120.006945 L26.4274843,120.006945 C25.1315456,120.006945 24.0809798,118.956379 24.0809798,117.660441 C24.0809798,116.364502 25.1315456,115.313936 26.4274843,115.313936 Z",
    id: "Rectangle",
    fill: "#F8F9FA",
    mask: "url(#mask-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF9F43",
    fillRule: "nonzero",
    mask: "url(#mask-5)",
    x: 83.6145131,
    y: 101.905339,
    width: 37.4593019,
    height: 4.69300903
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9610176,115.313936 L105.348988,115.313936 C106.644927,115.313936 107.695493,116.364502 107.695493,117.660441 C107.695493,118.956379 106.644927,120.006945 105.348988,120.006945 L85.9610176,120.006945 C84.6650789,120.006945 83.6145131,118.956379 83.6145131,117.660441 C83.6145131,116.364502 84.6650789,115.313936 85.9610176,115.313936 Z",
    id: "Rectangle",
    fill: "#F8F9FA",
    mask: "url(#mask-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#28C76F",
    mask: "url(#mask-5)",
    x: 145.154795,
    y: 101.905339,
    width: 37.4593019,
    height: 4.69300903
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.501299,115.313936 L166.88927,115.313936 C168.185209,115.313936 169.235774,116.364502 169.235774,117.660441 C169.235774,118.956379 168.185209,120.006945 166.88927,120.006945 L147.501299,120.006945 C146.205361,120.006945 145.154795,118.956379 145.154795,117.660441 C145.154795,116.364502 146.205361,115.313936 147.501299,115.313936 Z",
    id: "Rectangle",
    fill: "#F8F9FA",
    mask: "url(#mask-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.080980, 52.963959)",
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.167229, 0.167607)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.653108, 49.779417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.231338,38.549717 C29.8525127,38.549717 38.462676,29.9200689 38.462676,19.2748585 C38.462676,8.6296481 29.8525127,0 19.231338,0 C8.61016331,0 0,8.6296481 0,19.2748585 C0,29.9200689 8.61016331,38.549717 19.231338,38.549717 Z M19.231338,30.8397736 C12.8586332,30.8397736 7.6925352,25.6619848 7.6925352,19.2748585 C7.6925352,12.8877323 12.8586332,7.70994341 19.231338,7.70994341 C25.6040428,7.70994341 30.7701408,12.8877323 30.7701408,19.2748585 C30.7701408,25.6619848 25.6040428,30.8397736 19.231338,30.8397736 Z",
    id: "Oval",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.462676,19.2748585 C38.462676,8.6296481 29.8525127,0 19.231338,0 C17.1071031,0 15.3850704,1.72592962 15.3850704,3.8549717 C15.3850704,5.98401379 17.1071031,7.70994341 19.231338,7.70994341 C25.5316257,7.70994341 30.6525737,12.7707239 30.7681453,19.0575899 L30.7701408,19.2748585 C30.7701408,21.4039006 32.4921735,23.1298302 34.6164084,23.1298302 C36.7406434,23.1298302 38.462676,21.4039006 38.462676,19.2748585 Z",
    id: "Path",
    fill: "#28C76F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.450658, 49.779417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.231338,38.549717 C29.8525127,38.549717 38.462676,29.9200689 38.462676,19.2748585 C38.462676,8.6296481 29.8525127,0 19.231338,0 C8.61016331,0 0,8.6296481 0,19.2748585 C0,29.9200689 8.61016331,38.549717 19.231338,38.549717 Z M19.231338,30.8397736 C12.8586332,30.8397736 7.6925352,25.6619848 7.6925352,19.2748585 C7.6925352,12.8877323 12.8586332,7.70994341 19.231338,7.70994341 C25.6040428,7.70994341 30.7701408,12.8877323 30.7701408,19.2748585 C30.7701408,25.6619848 25.6040428,30.8397736 19.231338,30.8397736 Z",
    id: "Oval",
    fill: "#F2F2F2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.231338,38.549717 C29.8525127,38.549717 38.462676,29.9200689 38.462676,19.2748585 C38.462676,8.6296481 29.8525127,0 19.231338,0 C17.1071031,0 15.3850704,1.72592962 15.3850704,3.8549717 C15.3850704,5.98401379 17.1071031,7.70994341 19.231338,7.70994341 C25.6040428,7.70994341 30.7701408,12.8877323 30.7701408,19.2748585 C30.7701408,25.5894038 25.720787,30.7219404 19.4481161,30.8377736 L19.231338,30.8397736 C17.1071031,30.8397736 15.3850704,32.5657032 15.3850704,34.6947453 C15.3850704,36.8237874 17.1071031,38.549717 19.231338,38.549717 Z",
    id: "Path",
    fill: "#FF9F43",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.248209, 49.779417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.231338,38.549717 C29.8525127,38.549717 38.462676,29.9200689 38.462676,19.2748585 C38.462676,8.6296481 29.8525127,0 19.231338,0 C8.61016331,0 0,8.6296481 0,19.2748585 C0,29.9200689 8.61016331,38.549717 19.231338,38.549717 Z M19.231338,30.8397736 C12.8586332,30.8397736 7.6925352,25.6619848 7.6925352,19.2748585 C7.6925352,12.8877323 12.8586332,7.70994341 19.231338,7.70994341 C25.6040428,7.70994341 30.7701408,12.8877323 30.7701408,19.2748585 C30.7701408,25.6619848 25.6040428,30.8397736 19.231338,30.8397736 Z",
    id: "Oval",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,19.2748585 C0,29.9200689 8.61016331,38.549717 19.231338,38.549717 C29.8525127,38.549717 38.462676,29.9200689 38.462676,19.2748585 C38.462676,8.6296481 29.8525127,0 19.231338,0 C17.1071031,0 15.3850704,1.72592962 15.3850704,3.8549717 C15.3850704,5.98401379 17.1071031,7.70994341 19.231338,7.70994341 C25.6040428,7.70994341 30.7701408,12.8877323 30.7701408,19.2748585 C30.7701408,25.6619848 25.6040428,30.8397736 19.231338,30.8397736 C12.8586332,30.8397736 7.6925352,25.6619848 7.6925352,19.2748585 C7.6925352,17.1458164 5.97050254,15.4198868 3.8462676,15.4198868 C1.72203266,15.4198868 0,17.1458164 0,19.2748585 Z",
    id: "Path",
    fill: "#EA5455"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "VisaCard2",
    transform: "translate(161.964158, 53.351351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#BFB9FF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(30.218195, 18.956266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(0.000000, 1.115074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(114.829143, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#8E83FF",
    cx: 12.9826321,
    cy: 12.9348637,
    rx: 12.9826321,
    ry: 12.9348637
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-10",
    fill: "#FFBB7A",
    cx: 30.8897109,
    cy: 12.9348637,
    rx: 12.9826321,
    ry: 12.9348637
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8186717,3.68113534 L21.9377374,3.56969172 C24.419006,5.92559722 25.9652642,9.25032089 25.9652642,12.9348637 C25.9652642,16.6194066 24.419006,19.9441302 21.9377374,22.3000357 C19.453803,19.945132 17.9070788,16.6199616 17.9070788,12.9348637 C17.9070788,9.30804799 19.405265,6.02986489 21.8186717,3.68113534 L21.9377374,3.56969172 L21.8186717,3.68113534 Z",
    id: "Path",
    fillOpacity: 0.416193182,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.79070788,21.1864147 L28.8751646,21.1864147 C29.8641452,21.1864147 30.6658724,21.9851921 30.6658724,22.9705339 L30.6658724,42.5958444 C30.6658724,43.5811861 29.8641452,44.3799635 28.8751646,44.3799635 L1.79070788,44.3799635 C0.801727226,44.3799635 4.97021279e-14,43.5811861 4.97021279e-14,42.5958444 L4.97021279e-14,22.9705339 C4.97021279e-14,21.9851921 0.801727226,21.1864147 1.79070788,21.1864147 Z",
    id: "Rectangle",
    fill: "#9F95FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(0.000000, 0.669045)",
    fill: "#FFFFFF",
    fillOpacity: 0.64690778
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.02909273,57.9838719 L26.4129412,57.9838719 C28.6381477,57.9838719 30.4420339,59.7811209 30.4420339,61.9981399 C30.4420339,64.215159 28.6381477,66.012408 26.4129412,66.012408 L4.02909273,66.012408 C1.80388626,66.012408 -1.03380426e-13,64.215159 -1.03380426e-13,61.9981399 C-1.03380426e-13,59.7811209 1.80388626,57.9838719 4.02909273,57.9838719 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02909273,78.0552122 L59.988714,78.0552122 C62.2139204,78.0552122 64.0178067,79.8524612 64.0178067,82.0694802 C64.0178067,84.2864992 62.2139204,86.0837483 59.988714,86.0837483 L4.02909273,86.0837483 C1.80388626,86.0837483 -9.94042559e-14,84.2864992 -9.94042559e-14,82.0694802 C-9.94042559e-14,79.8524612 1.80388626,78.0552122 4.02909273,78.0552122 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.617029,78.0552122 L154.000878,78.0552122 C156.226084,78.0552122 158.02997,79.8524612 158.02997,82.0694802 C158.02997,84.2864992 156.226084,86.0837483 154.000878,86.0837483 L131.617029,86.0837483 C129.391823,86.0837483 127.587936,84.2864992 127.587936,82.0694802 C127.587936,79.8524612 129.391823,78.0552122 131.617029,78.0552122 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02909273,0 L26.4129412,0 C28.6381477,0 30.4420339,1.79724903 30.4420339,4.01426805 C30.4420339,6.23128708 28.6381477,8.02853611 26.4129412,8.02853611 L4.02909273,8.02853611 C1.80388626,8.02853611 0,6.23128708 0,4.01426805 C0,1.79724903 1.80388626,0 4.02909273,0 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1107279,57.9838719 L68.4945764,57.9838719 C70.7197829,57.9838719 72.5236691,59.7811209 72.5236691,61.9981399 C72.5236691,64.215159 70.7197829,66.012408 68.4945764,66.012408 L46.1107279,66.012408 C43.8855214,66.012408 42.0816352,64.215159 42.0816352,61.9981399 C42.0816352,59.7811209 43.8855214,57.9838719 46.1107279,57.9838719 Z",
    id: "Rectangle-Copy-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.087717,57.9838719 L111.471565,57.9838719 C113.696772,57.9838719 115.500658,59.7811209 115.500658,61.9981399 C115.500658,64.215159 113.696772,66.012408 111.471565,66.012408 L89.087717,66.012408 C86.8625105,66.012408 85.0586243,64.215159 85.0586243,61.9981399 C85.0586243,59.7811209 86.8625105,57.9838719 89.087717,57.9838719 Z",
    id: "Rectangle-Copy-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.169352,57.9838719 L153.553201,57.9838719 C155.778407,57.9838719 157.582293,59.7811209 157.582293,61.9981399 C157.582293,64.215159 155.778407,66.012408 153.553201,66.012408 L131.169352,66.012408 C128.944146,66.012408 127.140259,64.215159 127.140259,61.9981399 C127.140259,59.7811209 128.944146,57.9838719 131.169352,57.9838719 Z",
    id: "Rectangle-Copy-40"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Men1.1",
    transform: "translate(0.000000, 30.648649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(66.422744, 149.240360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0591818,209.110904 C52.0591818,209.110904 51.9050441,218.967628 57.9585163,222.468631 C64.0113094,225.970317 73.3892684,232.476178 73.3892684,232.476178 L37.7141842,233.684809 L38.7313577,209.022185 L52.0591818,209.110904 Z",
    id: "Path",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3380066,221.046391 C40.0968689,221.330976 39.4938983,225.321301 44.4996411,225.1268 C48.1466628,224.984849 53.8348217,218.258555 58.5139554,220.750205 C65.6558983,224.552854 74.0302642,229.680835 76.0836237,230.90175 C78.1369832,232.123347 78.9484133,236.729248 72.8806817,237.294323 C67.0784473,237.834828 59.2459401,237.774772 57.2842484,237.417165 C55.3218777,237.059557 51.6822282,234.556988 48.7542896,234.956908 C45.8263511,235.35751 45.4929518,236.366879 43.8565112,236.813873 C42.2200706,237.260867 37.2809688,237.357791 36.768987,235.979228 C36.1809548,234.396611 35.5915646,220.866905 37.3380066,221.046391 Z",
    id: "Path",
    fill: "#482B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5730331,-1.98621069e-14 C34.5730331,-1.98621069e-14 48.1819719,106.815408 49.3200111,116.917133 C50.4573713,127.018859 56.7050435,198.881559 55.8501561,208.467348 C54.9789721,218.22921 36.7167024,218.281759 34.2667946,210.916685 C30.913789,200.835433 23.1620852,150.451695 21.8800936,139.930259 C20.598102,129.408823 21.0482929,117.193528 15.8958816,106.420265 C12.2067605,98.7071387 -3.4583696e-14,2.73869912 -3.4583696e-14,2.73869912 L34.5730331,-1.98621069e-14 Z",
    id: "Path",
    fill: "#2F2B57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5744759,123.434695 L26.6229137,123.915356 C27.142366,129.494848 27.5777863,147.976374 27.9291746,179.359931 L27.1457974,174.672558 C24.6893605,159.809081 22.5082029,145.085216 21.8800936,139.930259 C20.6248101,129.628019 21.0302867,117.701764 16.2106785,107.095444 L15.8958816,106.420265 C14.2722979,103.025715 10.9989466,82.5371379 7.8424237,60.6581948 L8.83353333,63.3116576 C19.3724493,91.6533781 25.2862887,111.694728 26.5744759,123.434695 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    opacity: 0.590959821
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.1518355,
    y1: 222.464716,
    x2: 59.4450459,
    y2: 225.018239,
    id: "Path-10",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.1317676,
    y1: 223.463053,
    x2: 62.4249781,
    y2: 226.016576,
    id: "Path-10",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(29.167925, 151.854466)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-10)",
    points: "6.41843806 208.757875 3.22568133 230.313956 18.6571125 230.236156 18.1519209 208.357273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.382471024,233.801592 C0.330865428,232.543824 1.50180568,224.386738 3.22568133,221.157032 C4.47606107,218.814428 7.24873135,218.265463 11.3058818,218.249084 C16.5390966,218.22861 20.9126709,219.02026 20.9065597,221.157032 C20.8882261,227.695651 22.5463954,232.724675 22.6577548,233.299303 C22.985043,234.984972 18.3045512,236.243422 11.9115685,236.179271 C6.67903273,236.127404 0.462595502,235.762973 0.382471024,233.801592 Z",
    id: "Path",
    fill: "#482B61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3355918,0.893039536 C54.3355918,0.893039536 47.260193,48.566059 42.9776076,78.7299669 C38.7690354,108.369748 26.3054121,196.781669 25.0175022,206.036823 C23.8351773,214.533224 2.25364908,214.533224 2.48079529,204.243326 C2.70794151,193.953428 0.70990853,129.831649 4.72835479,120.337993 C8.74680106,110.844336 5.24848488,99.7953608 5.39447439,90.5726397 C5.54114293,81.3499186 11.3202906,1.50929802 11.3202906,1.50929802 L54.3355918,0.893039536 Z",
    id: "Path",
    fill: "#3A3669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6288809,62.7134015 L15.2911038,63.9403383 C11.1941863,78.6601222 9.78027834,79.9863123 10.9413969,103.463717 L10.9533246,103.940991 C10.9937478,109.847607 8.18461096,140.413706 2.52591401,195.63929 L2.50030531,192.206263 C2.30187582,169.676578 1.47186342,128.942157 4.62632221,120.593386 L4.72835479,120.337993 C8.74680106,110.844336 5.24848488,99.7953608 5.39447439,90.5726397 C5.54114293,81.3499186 11.3202906,1.50929802 11.3202906,1.50929802 L18.7024381,1.402558 L18.7779293,5.06009304 C19.3090097,33.6221358 18.2593269,52.8399052 15.6288809,62.7134015 L15.6288809,62.7134015 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    opacity: 0.46156529
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.4364518,
    y1: 223.030458,
    x2: 15.0852229,
    y2: 223.030458,
    id: "Path-9",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.4364518,
    y1: 226.025468,
    x2: 15.0852229,
    y2: 226.025468,
    id: "Path-9",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(52.241046, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.79404779,56.4292197 C4.79404779,56.4292197 10.705111,55.0345112 10.9101753,45.2999475 C11.1152397,35.5653838 10.9712872,32.2425016 10.9712872,32.2425016 L24.9849226,32.0063716 C24.9849226,32.0063716 25.1268525,42.8553866 25.128875,46.7795138 C25.1343072,57.3191816 32.4412561,56.4292197 32.4412561,56.4292197 C32.4412561,56.4292197 30.9222822,64.9751769 19.1242924,65.6419372 C9.9126935,66.1633342 4.79404779,56.4292197 4.79404779,56.4292197 Z",
    id: "Path",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head1",
    transform: "translate(0.582624, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.10191832,27.3218906 C3.2935727,27.0959974 4.24098137,35.6419751 10.274762,35.6303733 C10.274762,35.6303733 16.7592648,48.734775 26.9397999,48.768869 C31.8436896,48.7851569 33.4448211,44.3949123 34.9149015,41.3129374 C36.384982,38.2309625 37.4639464,33.6209669 37.5535771,30.7983256 C37.6499981,27.7886911 37.6622205,17.901257 37.6622205,17.901257 L8.87580432,17.8882903 L9.10191832,27.3218906 Z",
    id: "Path",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5296251,42.6655931 C27.4455933,43.0523144 28.4635767,42.8259116 29.2234227,42.3824636",
    id: "Path",
    stroke: "#F49494",
    strokeLinecap: "round",
    transform: "translate(27.876524, 42.622915) rotate(6.000000) translate(-27.876524, -42.622915) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68206002,32.3435294 C10.0486187,31.0212533 9.88811343,29.866871 8.58188102,29.3407901",
    id: "Path-8",
    stroke: "#DE6767",
    strokeLinecap: "round",
    transform: "translate(9.217431, 30.842160) rotate(-13.000000) translate(-9.217431, -30.842160) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10191832,27.3218906 C9.10191832,27.3218906 11.7725079,30.4202445 12.7604835,30.5055516 C13.749138,30.5908587 12.6226422,22.1202049 14.0777842,20.5771701 C17.273936,17.1860423 25.6256588,22.9483556 34.4083519,21.5407991 C36.5775976,21.1931454 37.6428882,22.8726497 37.6042236,26.5793119 C45.8142665,19.0545433 48.7906956,13.1185998 38.9802002,10.6399167 C38.9014338,4.2712299 35.2564491,2.67291609 28.2082111,5.62727155 C27.2660695,-2.97591663 15.0878279,-1.67719846 9.54446586,9.26743977 C5.5321661,5.34351719 -0.107529069,8.5109422 2.28590554,14.4152677 C-2.03473305,14.4152677 0.216792124,26.0235199 5.3084628,30.0113169 C5.91596497,28.2693112 7.02618765,27.3218906 9.10191832,27.3218906 Z",
    id: "Path",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7641763,38.9618296 C24.7641763,38.9618296 26.7587067,42.203886 30.6636692,41.0453871",
    id: "Path",
    stroke: "#DE6767",
    strokeLinecap: "round",
    transform: "translate(27.713923, 40.128661) rotate(-15.000000) translate(-27.713923, -40.128661) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(85.165830, 62.327068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(85.966438, 17.488965) rotate(4.000000) translate(-85.966438, -17.488965) translate(73.966438, 2.488965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.94013428e-14,23.7281795 C-7.94013428e-14,23.7281795 1.01384208,14.3950043 2.98164493,11.012066 C4.94944778,7.6284452 5.20929182,2.15686869 7.29320726,2.21146523 C9.3771227,2.26674423 7.9099156,11.0754306 7.9099156,11.0754306 C7.9099156,11.0754306 17.0556494,3.15893172 21.2608265,0.357446577 C25.0972951,-2.19767167 23.7283888,9.73030821 23.2089377,11.2747079 C21.9717614,14.9517852 5.70648487,29.6395256 5.70648487,29.6395256 C5.70648487,29.6395256 0.433215396,24.5218768 -7.94013428e-14,23.7281795 Z",
    id: "Path",
    fill: "url(#linearGradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9099156,11.0754306 C7.57288062,13.0843836 7.52298495,14.0805233 7.7602286,14.0638497 C7.99747225,14.047176 10.1196238,11.3097149 14.1266832,5.85146634 L7.9099156,11.0754306 Z",
    id: "Path",
    fill: "#F28585"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.5275602,4.67897816 C22.2588583,14.9392903 39.9549287,41.4503328 39.9549287,41.4503328 C39.9549287,41.4503328 68.9531552,22.5444543 72.6429553,22.5055543 C76.3327554,22.4666542 81.3432514,27.3625993 81.0281856,30.7414429 C80.7131199,34.1202865 48.9629356,63.7565611 38.7803368,63.5074644 C22.9469252,63.1191465 3.0921941,21.9464246 1.05344272,16.4430791 C-4.40727039,1.70259093 12.9126749,-5.3288806 17.5275602,4.67897816 Z",
    id: "Path",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8497189,41.4309771 C42.0821667,44.7012587 43.3983311,46.2290619 43.798212,46.0143869 C44.1980929,45.7997118 43.7592884,43.8009002 42.4817983,40.017952 L39.8497189,41.4309771 Z",
    id: "Path-5",
    fillOpacity: 0.159855769,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(32.507974, 55.667711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.14909295,12.9797659 C-1.33660499,20.1039324 8.83783679,56.0084702 6.03859732,72.8051902 C3.82463361,86.0899873 1.71112203,104.381407 7.44924769,108.442505 C13.2913073,112.577161 63.5789737,115.860358 70.7469061,104.381407 C76.4335342,95.2746638 71.7783389,75.0792395 70.7469061,65.8667553 C68.6901515,47.4875113 71.7959935,15.725972 68.3065046,9.22966577 C66.1417856,5.1997584 51.3842107,0.0028498955 50.8298622,0.163909699 C50.2755136,0.324969503 48.9724002,6.03503305 39.6408,6.03503305 C30.3091998,6.03503305 26.188502,0.163909699 25.6870727,0.0028498955 C25.1856433,-0.158209908 1.49355452,6.53532634 0.14909295,12.9797659 Z",
    id: "Path",
    fill: "#EA5455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6635824,3.40471175e-05 L25.6870727,0.0028498955 C26.188502,0.163909699 30.3091998,6.03503305 39.6408,6.03503305 C48.9724002,6.03503305 50.2755136,0.324969503 50.8298622,0.163909699 C51.0299423,0.105778651 53.0802663,0.745626227 55.7209395,1.77666225 L55.7089164,1.89795249 C49.0391573,13.0981729 30.6963276,14.4786237 20.8915146,1.66473547 L20.6694475,1.3684923 L21.763502,1.02912427 C23.7661526,0.420204287 25.1991893,0.0543967746 25.5888858,0.00560011385 L25.6635824,3.40471175e-05 Z",
    id: "Path",
    fill: "#FF9B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.180637509,17.9281805 L1.00282989,18.0424977 C9.72505843,19.2900713 14.840579,21.2639132 16.3493917,23.9640235 C17.3393465,25.7356066 16.8790377,31.7278266 14.9684653,41.9406834 L14.7656465,43.0122416 C12.9936482,52.2696985 15.0197239,61.8461964 20.3691766,69.5719603 L20.6697845,69.9992516 C22.4788601,72.5303523 24.1466208,75.8629814 25.6730669,79.9971389 C29.2137687,89.5866156 21.6823499,97.6669997 26.4522877,111.933398 L25.4784595,111.861948 C16.6118292,111.18302 9.44096705,109.852123 7.44924769,108.442505 C1.71112203,104.381407 3.82463361,86.0899873 6.03859732,72.8051902 C8.42040181,58.5132714 1.40940061,30.387498 0.180637509,17.9281805 Z",
    id: "Path",
    fillOpacity: 0.0667613636,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rarm",
    transform: "translate(0.000000, 61.672544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(36.332608, 83.285204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54779948,0 C6.54779948,0 9.89557882,3.9491321 12.7529287,4.44056384 C15.6102785,4.93199557 27.5682394,7.27100201 28.2980629,7.61734208 C28.9879284,7.94471991 31.3470043,9.18655093 33.3643757,11.1793248 C35.1121758,12.9059405 38.1358563,16.9993163 37.1220779,17.7036117 C36.0383604,18.457044 33.1124589,14.7649528 31.6444155,13.852508 C30.1050749,12.8950212 27.7393658,12.0474098 27.7393658,12.0474098 C27.7393658,12.0474098 33.5911687,19.1067429 33.2190652,20.3399423 C32.9474568,21.2401029 27.9714538,22.7772569 26.9074279,22.6619217 C25.843402,22.5465865 19.9801928,18.2536719 17.3449124,17.7541135 C15.5169878,17.4081079 7.33342677,15.1914883 5.6073554,13.5269761 C3.88196304,11.8617816 -3.9524224e-14,8.48293797 -3.9524224e-14,8.48293797 L6.54779948,0 Z",
    id: "Path",
    fill: "url(#linearGradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.091012,21.1583032 C28.0084723,17.0447404 25.8820229,15.0230168 25.7116637,15.0931326 C25.5413044,15.1632485 27.319966,17.3281132 31.0476484,21.5877269 L32.091012,21.1583032 Z",
    id: "Path",
    fill: "#F28585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.361547,22.1716564 C26.3033112,19.3696174 24.6742441,18.0360991 24.4743456,18.1711016 C24.2744471,18.306104 25.499183,19.753778 28.1485534,22.5141236 L29.361547,22.1716564 Z",
    id: "Path",
    fill: "#F28585"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.208968,1.02322684 C55.6644984,7.67660628 49.3474031,19.7709975 41.5026735,30.8650151 C34.1746789,41.2274391 23.0679324,56.836591 23.0679324,56.836591 C23.0679324,56.836591 43.9525813,79.7125428 45.9699526,83.9451398 C47.987324,88.1777369 42.8355917,96.1269936 36.4310657,93.9560985 C30.0258606,91.7852035 -6.4223644,64.7860597 0.989564712,52.0266355 C12.3105747,32.5378402 35.0404307,-6.83550918 46.208968,1.02322684 Z",
    id: "Path",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0679324,56.836591 C20.2107661,53.813937 18.9156504,52.1277584 19.1825852,51.7780551 C19.44952,51.4283519 21.1930473,52.4888221 24.413167,54.9594658 L23.0679324,56.836591 Z",
    id: "Path-6",
    fillOpacity: 0.159855769,
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(348.845878, 160.054054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2218727,155.618514 L123.352559,155.618514 L123.352559,155.618514 L123.352559,238.078351 C123.352559,240.28749 121.561698,242.078351 119.352559,242.078351 L22.1105127,242.078351 C19.9013737,242.078351 18.1105127,240.28749 18.1105127,238.078351 L18.1105127,179.729874 C18.1105127,166.413537 28.9055362,155.618514 42.2218727,155.618514 Z",
    id: "Rectangle",
    fill: "#86E5F0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#86E5F0",
    points: "27.6188829 225.011524 104.398358 225.011524 104.398358 242.078351 27.6188829 242.078351"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#86E5F0",
    points: "125.399122 241.459957 130.24253 253.58994 106.829037 253.58994 110.886454 241.459957"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#91D6FF",
    points: "45.628238 241.459957 50.4716464 253.58994 27.0581537 253.58994 31.1155705 241.459957"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#86E5F0",
    points: "204.172869 241.459957 209.016278 253.58994 185.602785 253.58994 189.660202 241.459957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.538383,66.3327791 L123.949748,65.8467061 L123.949748,65.8467061 L123.949748,163.774247 L77.9498434,163.774247 L77.9498434,90.4384701 C77.9498434,77.3258684 88.4288639,66.6171073 101.538383,66.3327791 Z",
    id: "Rectangle",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.035428,65.8467061 L187.266259,65.8467061 C199.328158,65.8467061 209.106259,75.6248071 209.106259,87.6867061 L209.106259,164.022401 C209.106259,164.987353 208.324011,165.769601 207.359059,165.769601 L86.9240678,165.769601 L86.9240678,165.769601 L86.9240678,89.9580661 C86.9240678,76.6417297 97.7190914,65.8467061 111.035428,65.8467061 Z",
    id: "Rectangle",
    fill: "#C6F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.032737,65.8467061 C201.462183,65.8467061 209.106259,73.4907822 209.106259,82.9202279 L209.106259,154.045628 C209.106259,155.01058 208.324011,155.792828 207.359059,155.792828 L174.959215,155.792828 L174.959215,155.792828 L174.959215,82.9202279 C174.959215,73.4907822 182.603291,65.8467061 192.032737,65.8467061 Z",
    id: "Rectangle",
    fill: "#86E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2188829,164.820132 L118.49866,164.820132 L118.49866,164.820132 L118.49866,230.573615 L27.6188829,230.573615 L27.6188829,177.420132 C27.6188829,170.461344 33.2600951,164.820132 40.2188829,164.820132 Z",
    id: "Rectangle",
    fill: "#C6F9FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Wom1.4",
    transform: "translate(82.662928, 127.500000) scale(-1, 1) translate(-82.662928, -127.500000) translate(0.662928, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(32.719433, 0.465078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0056596,56.8752086 C-2.19250823,54.0329972 -2.99586491,37.2806692 6.27808458,31.4695688 C-3.28604708,11.4097845 18.8310926,-8.50697349 33.9811336,3.77601323 C43.913154,-0.477638777 52.1667918,16.1209846 42.9249766,29.012535 C46.7999031,51.1477026 38.9136463,56.8694212 24.6974465,57.1124882 L10.0056596,56.8752086 Z",
    id: "Path",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1574171,52.8742814 C10.1574171,52.8742814 16.0912443,51.4804941 16.2970984,41.7523604 C16.5029524,32.0242267 16.3584456,28.7035394 16.3584456,28.7035394 L29.4289127,28.4675653 C29.4289127,28.4675653 29.5713892,39.3094143 29.5734195,43.2309494 C29.5788726,53.7636554 36.9139613,52.8742814 36.9139613,52.8742814 C36.9139613,52.8742814 35.3891376,61.4145937 23.5457126,62.0809136 C14.2986391,62.6019662 10.1574171,52.8742814 10.1574171,52.8742814 Z",
    id: "Path",
    fill: "url(#linearGradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3115714,23.8457333 C7.48085733,23.6199893 8.43191455,32.1603221 14.4889318,32.148728 C14.4889318,32.148728 18.0069398,44.2807768 30.2210123,44.2807768 C40.1404142,44.2807768 40.7856882,30.1406488 40.8756641,27.3198719 C40.9724564,24.3122254 40.9847259,14.4313223 40.9847259,14.4313223 L13.0845866,14.4183642 L13.3115714,23.8457333 Z",
    id: "Path",
    fill: "url(#linearGradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0824059,35.1582406 C28.0824059,35.1582406 30.0876252,38.4012871 34.0052272,37.2475322",
    id: "Path",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(31.043817, 36.326987) rotate(-18.000000) translate(-31.043817, -36.326987) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7818223,39.0292407 C30.7010721,39.4152636 31.5729746,39.4152801 32.33593,38.9717159",
    id: "Path",
    stroke: "#F49494",
    strokeLinecap: "round",
    transform: "translate(31.058876, 39.141832) rotate(2.000000) translate(-31.058876, -39.141832) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5801623,28.5824793 C13.9467413,27.2611372 13.7845131,26.1070952 12.4730282,25.5799499",
    id: "Path-8",
    stroke: "#F77B7B",
    strokeLinecap: "round",
    transform: "translate(13.111813, 27.081215) rotate(-13.000000) translate(-13.111813, -27.081215) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3890484,22.7905357 C12.3890484,22.7905357 15.5849403,27.0812197 16.2323068,27.1040094 C16.8796733,27.1267991 17.1063588,21.5237582 17.1063588,21.5237582 C21.0267394,21.2241043 30.9484107,19.247287 33.380515,14.6420253 C35.0813558,18.7054434 38.3326977,20.5103363 40.4689448,20.1637408 L40.8738366,28.7964755 L41.8709726,11.4410101 L11.6073573,11.4410101 L12.3890484,22.7905357 Z",
    id: "Path",
    fill: "#422851"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg",
    transform: "translate(36.894034, 131.693412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7021733,93.1980305 C65.7021733,93.1980305 60.4713359,103.768624 64.7594396,107.099676 C69.0539916,110.431374 80.397795,116.674758 80.397795,116.674758 L50.3443073,114.785033 L57.0247215,91.7308964 L65.7021733,93.1980305 Z",
    id: "Path",
    fill: "url(#linearGradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2513328,103.257643 C54.7344364,103.431196 53.1505072,108.427219 56.3617488,108.807229 C59.5665421,109.186593 61.1241757,104.45325 64.7610035,105.953841 C68.3978313,107.454432 81.6615188,115.212693 82.1838292,118.384387 C82.7125879,121.555435 77.7708615,122.488549 70.9937231,121.772401 C64.2165847,121.056254 62.9674615,118.643933 57.8797715,119.61557 C52.7985298,120.586563 48.9920117,119.038694 49.1596669,115.32376 C49.327322,111.609473 51.7682293,103.084735 53.2513328,103.257643 Z",
    id: "Path",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4198249,106.723489 L65.7597068,107.713936 C65.453412,108.173503 65.5776637,108.794356 66.0372308,109.100651 C66.0590481,109.115192 66.0814289,109.12887 66.1043213,109.141651 L75.0699217,114.147582 C75.3606632,114.309918 75.7131358,114.316882 76.0100628,114.166158 L77.4019447,113.459621 L77.4019447,113.459621 C75.2160499,111.87556 73.4285878,110.685366 71.4533439,109.516708 C69.9369242,108.619514 68.2580621,107.694559 66.4198249,106.723489 Z",
    id: "Path-14",
    fillOpacity: 0.54097465,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4297468,0.0315435604 C29.5282647,0.438005503 80.1680515,11.644498 89.3684437,13.5484027 C98.5688359,15.4523074 106.347172,25.754471 99.3314473,37.6838064 C91.4516537,51.0751145 71.1203434,89.106119 66.1840592,97.6792482 C63.7408052,101.922588 51.4149997,99.5434516 54.3102757,92.4213265 C59.7075898,79.1444076 62.2141077,45.7915218 75.9747293,33.6305676 C75.9747293,33.6305676 29.6979111,41.6888813 9.70825463,32.4583242 C-4.8197118,25.7484762 -1.53308213,-0.951062056 20.4297468,0.0315435604 Z",
    id: "Path",
    fill: "url(#linearGradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm",
    transform: "translate(64.335218, 56.189189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4555354,21.7037492 C57.4555354,21.7037492 57.3527218,14.2965681 59.942338,10.4255399 C62.5319541,6.55451181 62.6347677,2.44263115 64.5946509,2.57722521 C66.5545341,2.71181926 64.6139284,12.2692853 64.6139284,12.2692853 C64.6139284,12.2692853 67.100731,11.3187551 68.8871164,10.1164244 C70.6735017,8.91409376 76.0904903,2.9868033 77.3563821,4.03715214 C79.5026149,5.82680231 76.0455094,15.9220006 74.1627364,17.9402675 C72.2735375,19.9591784 61.953628,26.5980785 61.953628,26.5980785 L57.4555354,21.7037492 Z",
    id: "Path",
    fill: "url(#linearGradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54220616,17.2652177 C5.77462022,27.0871682 13.5242759,45.130442 16.7191037,50.51357 C20.722897,57.2550903 27.0363457,60.2252538 34.4284151,55.2233671 C42.195657,49.9675151 63.5829982,29.4681252 64.2102397,24.8246055 C64.831619,20.1810857 59.5967911,14.6096831 54.8602391,17.4942139 C50.1236871,20.3787447 30.442208,36.7665931 30.442208,36.7665931 C30.442208,36.7665931 22.499104,16.3942278 16.1094485,4.5927549 C10.575655,-5.61747525 -4.90020804,2.33345995 1.54220616,17.2652177 Z",
    id: "Path",
    fill: "#6A5EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.524277,36.7771505 C31.9465183,41.6037469 32.8238746,43.877314 33.1563461,43.5978517 C33.4888175,43.3183895 33.361806,40.4141123 32.7753116,34.8850203 L30.524277,36.7771505 Z",
    id: "Path",
    fillOpacity: 0.302802666,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PhoneMini4",
    transform: "translate(135.988280, 69.688862) scale(-1, 1) rotate(-18.000000) translate(-135.988280, -69.688862) translate(126.488280, 52.188862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93304014,1.23871603 L14.8849257,1.23871603 C16.2104091,1.23871603 17.2849257,2.31323263 17.2849257,3.63871603 L17.2849257,32.3606755 C17.2849257,33.6861589 16.2104091,34.7606755 14.8849257,34.7606755 L2.93304014,34.7606755 C1.60755674,34.7606755 0.533040139,33.6861589 0.533040139,32.3606755 L0.533040139,3.63871603 C0.533040139,2.31323263 1.60755674,1.23871603 2.93304014,1.23871603 Z",
    id: "Rectangle",
    fill: "#7596FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#93C2F9",
    x: 1.79484488,
    y: 0.798141892,
    width: 16.7518856,
    height: 33.5219595
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78912482,1.99535473 L6.05960957,1.99535473 C6.31843816,1.99535473 6.53370535,2.18196445 6.57834709,2.42805083 L6.58684151,2.52287289 C6.58684151,2.81421312 6.82289128,3.05039104 7.11407344,3.05039104 L13.2403275,3.05039104 C13.4991561,3.05039104 13.7144233,2.86378132 13.759065,2.61769494 L13.7675594,2.52287289 C13.7675594,2.23153265 14.0036092,1.99535473 14.2947914,1.99535473 L15.5588633,1.99535473 C16.4978768,1.99535473 17.2679873,2.71890712 17.3426508,3.63918212 L17.348583,3.78763036 L17.348583,3.78763036 L17.3244878,31.0476697 C17.3215308,32.2370877 16.3575439,33.2007453 15.1687692,33.2026548 L5.11763781,33.2026548 C3.97983745,33.2044742 3.04810146,32.321808 2.9692318,31.2034738 L2.96382395,31.0495739 C2.96382395,31.0489386 2.96382395,31.0483033 2.96572874,31.0476697 L2.98981827,3.79404664 C2.99069656,2.80039932 3.79601624,1.99535473 4.78912482,1.99535473 Z",
    id: "Rectangle",
    fill: "#E6F3FF",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(23.579496, 51.612781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.0068988 C0,10.0068988 10.1994164,44.1777383 10.5014785,50.6460197 C10.8035406,57.1149441 2.15942275,76.1268945 3.63117218,80.9322893 C7.02455079,92.0368476 50.3479697,96.8184502 52.0031766,81.8801218 C52.7751121,74.9133635 51.1686594,68.6606239 53.0195932,60.4516488 C54.8641001,52.2426737 62.2782438,40.0440221 58.0730475,28.5751555 C53.8678513,17.1062889 54.9945847,6.49580412 51.9868173,4.49030809 C48.9790499,2.48481206 41.9480723,0.3549549 41.9480723,0.3549549 C38.5289863,5.38926996 26.9863575,5.31596405 21.4785441,-5.67113923e-14 C21.4785441,-5.67113923e-14 7.7957732,2.65573141 0,10.0068988 Z",
    id: "Path",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13993678,15.5412316 C15.9386181,26.3364714 15.9181784,45.1319964 19.5695599,47.5935645 C23.2209414,50.0551327 37.4324646,47.6395139 37.4324646,49.5889193 C37.4324646,51.5383247 17.7930336,69.4035203 21.0171234,77.9439199 C22.7053166,82.4158315 22.2473825,86.4165047 19.643321,89.9459395 L18.7933156,89.7606111 C11.05522,88.0108765 4.83413692,84.8688946 3.63117218,80.9322893 C2.15942275,76.1268945 11.8006767,57.1149441 11.4986145,50.6460197 C11.2422035,45.1552986 3.13546325,19.7027258 0.690954066,12.1347725 C2.68117146,8.62160914 5.49701697,9.75684617 9.13993678,15.5412316 Z",
    id: "Path",
    fillOpacity: 0.199355332,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm",
    transform: "translate(0.000000, 58.763197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3127259,37.0311967 C44.3127259,37.0311967 52.9036214,29.4236106 55.5334874,28.5407597 C58.1633534,27.6579088 73.5659264,26.5973287 73.468524,28.5922755 C73.3581345,30.7295345 65.0854203,30.6065407 64.2282788,31.6581056 C63.3711373,32.7090266 63.1763324,39.8954715 59.9360778,40.7023367 C56.7023167,41.5092019 47.0075268,42.9001267 47.0075268,42.9001267 L44.3127259,37.0311967 Z",
    id: "Path",
    fill: "url(#linearGradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4575573,4.8202439 C12.4065222,17.6012139 4.67897106,37.0697477 1.71276397,44.6599699 C-1.25344311,52.2501922 1.73872457,63.6986607 14.7818288,61.4510963 C27.8014848,59.2093971 48.5168693,47.029025 50.8089385,43.4758555 C53.1010076,39.922686 49.6189384,33.4573353 45.2341105,34.3036911 C41.1716965,35.0867022 21.0212518,43.6594379 21.0212518,43.6594379 C21.0212518,43.6594379 33.9847995,20.6687405 37.1503169,14.505534 C42.4379034,4.21260382 29.4299716,-6.44103936 21.4575573,4.8202439 Z",
    id: "Path",
    fill: "#6A5EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2264243,43.5022491 C16.6998549,45.7523724 14.7126134,46.4055938 15.2646998,45.4619135 C15.8167861,44.5182332 18.6677058,42.3887279 23.8174589,39.0733976 L21.2264243,43.5022491 Z",
    id: "Path",
    fillOpacity: 0.302802666,
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg",
    transform: "translate(21.936993, 127.702703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.262189,97.6131215 C112.262189,97.6131215 112.104495,110.054728 122.350806,114.706459 C132.590669,119.357545 139.88624,119.077538 138.957689,122.673758 C138.029137,126.269334 111.375733,126.124171 108.886698,123.311841 C106.765216,120.919522 102.151935,98.642182 100.881624,100.345451 L112.262189,97.6131215 Z",
    id: "Path",
    fill: "url(#linearGradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.155506,111.539927 C105.299738,109.327954 105.371668,115.550658 109.884896,114.179257 C113.547517,113.066323 114.799534,106.697074 117.113971,108.092005 C119.428407,109.486937 139.800658,120.303466 139.916727,120.368629 C142.425106,121.720276 141.724087,125.815774 137.487569,126.530631 C132.780328,127.324199 108.389539,126.789994 107.080538,125.534478 C105.771538,124.278963 103.237955,113.313692 104.155506,111.539927 Z",
    id: "Path",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.127339,111.812176 C119.786939,111.812176 119.456409,112.086044 119.135751,112.633778 C118.856757,113.110395 119.016933,113.722948 119.493537,114.001965 C119.533497,114.025359 119.575034,114.045949 119.617848,114.063586 L130.349806,118.484725 C130.758546,118.653075 131.226385,118.458233 131.394765,118.049505 C131.481134,117.839852 131.474528,117.603404 131.376588,117.398901 C131.376588,117.398901 131.376588,117.398901 131.376588,117.398901 C131.177862,116.983951 120.894869,111.812176 120.127339,111.812176 Z",
    id: "Path-14",
    fillOpacity: 0.54097465,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88108479,0.176050568 C-2.93730282,18.8096444 -1.15014795,31.325637 11.2425494,37.7240284 C29.2196896,47.0056866 83.0371228,36.0279769 83.0371228,36.0279769 C83.0371228,36.0279769 82.0754518,43.7747333 83.0371228,50.6839063 C85.548771,68.7289672 97.4939384,98.7929606 100.02124,102.570575 C103.516206,107.794578 114.162568,103.85487 114.363107,99.5050672 C114.563647,95.1552643 106.337337,39.6009559 105.086372,29.0071383 C103.841854,18.4126755 99.9127712,16.8737913 88.4369222,13.9777241 C85.8005061,13.3123931 54.6232684,5.56013886 51.7671658,5.78609393 C35.4067846,7.08041403 20.1114242,5.21039958 5.88108479,0.176050568 Z",
    id: "Path",
    fill: "#2C3757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3814608,34.8394634 C38.17943,36.8348181 85.2988183,32.7218352 87.1912383,34.5907796 C88.9979803,36.3751087 88.69653,67.4184419 92.7494691,85.3860522 L92.1330864,83.6893523 C88.3214526,73.0970618 84.3636275,60.2142452 83.0371228,50.6839063 C82.0754518,43.7747333 83.0371228,36.0279769 83.0371228,36.0279769 L80.8671382,36.4482363 C70.637039,38.3708923 27.0624327,45.8918876 11.2425494,37.7240284 C2.6707951,33.2984028 -0.827074088,25.9460051 0.748941804,15.6668353 C3.46276208,27.2852244 10.0069181,33.6763592 20.3814608,34.8394634 Z",
    id: "Path",
    fillOpacity: 0.192498907,
    fill: "#FFFFFF",
    opacity: 0.46156529
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M127.975573,155.618514 L209.106259,155.618514 L209.106259,155.618514 L209.106259,240.331151 C209.106259,241.296103 208.324011,242.078351 207.359059,242.078351 L103.864213,242.078351 L103.864213,242.078351 L103.864213,179.729874 C103.864213,166.413537 114.659236,155.618514 127.975573,155.618514 Z",
    id: "Rectangle",
    fill: "#86E5F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-80",
    transform: "translate(571.000000, 335.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20 L8,20 C15.7319865,20 22,26.2680135 22,34 L22,34 L22,34 L14,34 C6.2680135,34 9.46895252e-16,27.7319865 0,20 L0,20 L0,20 Z",
    id: "Rectangle",
    fill: "#2CE780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,12 L16,12 C19.8659932,12 23,15.1340068 23,19 L23,19 L23,19 L17,19 C13.1340068,19 10,15.8659932 10,12 L10,12 L10,12 Z",
    id: "Rectangle",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,19 L29,19 C35.627417,19 41,24.372583 41,31 L41,31 L41,31 L34,31 C27.372583,31 22,25.627417 22,19 L22,19 L22,19 Z",
    id: "Rectangle",
    fill: "#28C76F",
    transform: "translate(31.500000, 25.000000) scale(-1, 1) translate(-31.500000, -25.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7396169,8.67466788 L25.8856693,8.68523883 C30.6834316,8.69349077 34.5707228,12.5808056 34.5789454,17.378568 L34.5789454,17.378568 L34.5789454,17.378568 L28.432893,17.367997 C23.6351307,17.3597451 19.7478396,13.4724302 19.7396169,8.67466788 L19.7396169,8.67466788 L19.7396169,8.67466788 Z",
    id: "Rectangle",
    fill: "#2CE780",
    transform: "translate(27.159281, 13.026618) scale(-1, 1) rotate(22.000000) translate(-27.159281, -13.026618) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7647005,5 C20.8928207,6.98324811 22.8770996,10.755685 22.9944865,14.8967088 L23,15.2859663 L23,45 L21.3949572,45 L21.3949572,15.2859663 C21.3949572,11.8023835 19.8186585,8.58925776 17.2673788,6.82801802 L17,6.65104839 L17.7647005,5 Z",
    id: "Path",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-84",
    transform: "translate(4.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#DA4E4F",
    xlinkHref: "#path-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.01269239,-1.98366878 L9.1142315,-1.98366878 C4.64529684,15.0632551 15.5299458,29.2003345 9.1142315,46.6162162 L-1.01269239,46.6162162 L-1.01269239,-1.98366878 Z",
    id: "Rectangle",
    fill: "#E95B5C",
    mask: "url(#mask-23)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.257949082,
    fill: "#FFDFE2",
    mask: "url(#mask-23)",
    x: -2.69835458e-13,
    y: 26.7795285,
    width: 37.0645414,
    height: 3.96733755
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.257949082,
    fill: "#FFDFE2",
    mask: "url(#mask-23)",
    x: 1.87085917e-13,
    y: 15.8693502,
    width: 37.0645414,
    height: 3.96733755
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.1034284,2.47455046 L16.0122111,2.48099316 C20.1249072,2.48639101 23.4575541,5.8190562 23.4629294,9.93175233 L23.4629294,9.93175233 L23.4629294,9.93175233 L18.5541467,9.92530963 C14.4414506,9.91991177 11.1088037,6.58724658 11.1034284,2.47455046 L11.1034284,2.47455046 L11.1034284,2.47455046 Z",
    id: "Rectangle",
    fill: "#2CE780",
    transform: "translate(17.283179, 6.203151) rotate(16.000000) translate(-17.283179, -6.203151) "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.477a1e51dca998e20295df8f5749fb48.svg";
export { ForwardRef as ReactComponent };